module.exports = __webpack_public_path__ + "static/media/flagUnhealthy.75599365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Flags/flagUnhealthy.svg
// module id = 893
// module chunks = 0